export default function removeQueryParams(params: string[]) {
  if (typeof window === 'undefined') return '';

  const queryParams = new URLSearchParams(window.location.search);

  params.forEach((param) => {
    queryParams.delete(param);
  });

  const newQueryParams = queryParams.toString();

  return newQueryParams ? `?${newQueryParams}` : '';
}
